/**
 * Registre des workspaces — une entrée par entrée du rail.
 * AJOUTER UN MODE FUTUR : créer le workspace dans src/workspaces/<id>/ et
 * ajouter une ligne ici. C'est le seul câblage nécessaire.
 */
import type { WorkspaceDef } from "../shell/types.js";
import { accountWorkspace } from "./account/AccountWorkspace.js";
import { audioWorkspace } from "./audio/AudioWorkspace.js";
import { imageWorkspace } from "./image/ImageWorkspace.js";
import { libraryWorkspace } from "./library/LibraryWorkspace.js";
import { toolsWorkspace } from "./tools/ToolsWorkspace.js";
import { videoWorkspace } from "./video/VideoWorkspace.js";

export const WORKSPACES: WorkspaceDef[] = [
	imageWorkspace,
	videoWorkspace,
	audioWorkspace,
	toolsWorkspace,
	libraryWorkspace,
	accountWorkspace,
];
